import React, { useState } from 'react';
import MouseLightEffect from './MouseLightEffect';
import { useTrack } from '../analytics/TrackingContext';

function CargaBateria({ capacidadBateria }) {
  const { trackEvent } = useTrack();
  const [tiempoCarga, setTiempoCarga] = useState('');
  const [potenciaCarga, setPotenciaCarga] = useState('');
  const [resultado, setResultado] = useState(null);
  const [animarResultado, setAnimarResultado] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showInfo, setShowInfo] = useState(false);


  const calcularCarga = () => {
    if (!tiempoCarga || !potenciaCarga) {
      setErrorMessage('Por favor, introduce todos los datos.'); // Mostrar mensaje de error
      setResultado(null); // Asegurar que no hay resultado previo
      trackEvent('calculation_error', {
        screen: 'calculator', section: 'datos_ve', tool: 'carga_bateria',
        properties: { error_code: 'missing_required' },
      });
      return; // Salir de la función si falta algún dato
    }

    const carga = parseFloat(tiempoCarga) * parseFloat(potenciaCarga);
    setResultado(carga.toFixed(2));
    setAnimarResultado(true); // Activar la animación
    setErrorMessage('');
    trackEvent('calculation_success', {
      screen: 'calculator', section: 'datos_ve', tool: 'carga_bateria',
    });
  };

  return (
    <MouseLightEffect>
    <div className="section-container">

      <div className="tooltip-wrapper" style={{ position: 'absolute', top: '12px', right: '12px' }}>
        <button
          onClick={() => setShowInfo(true)}
          aria-label="Más información"
          style={{ background: 'transparent', border: '1px solid #ccc', borderRadius: '50%', width: '28px', height: '28px', cursor: 'pointer', fontSize: '1rem', lineHeight: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Kiafontl' }}
        >ℹ</button>
        <span className="tooltip-text tooltip-left">Más información</span>
      </div>

      <h2 style={{ textAlign: 'center', width: '100%' }}>¿Cuánto se cargará la batería?</h2>

      {showInfo ? (
        <div className="info-panel">
          <p>Calcula cuánta energía absorbe la batería durante una sesión de carga. Introduce el tiempo que el vehículo estará conectado al cargador y la potencia de carga disponible. Útil para estimar cuántos kWh recuperas en una parada corta.</p>
          <div className="button">
            <button className="calc" onClick={() => setShowInfo(false)}>← Volver</button>
          </div>
        </div>
      ) : (
        <>
          <div className="input">
          <label htmlFor="tiempo_input">Tiempo de Carga (Horas): </label>
          <input
              id="tiempo_input"
              type="number"
              value={tiempoCarga}
              onChange={(e) => setTiempoCarga(e.target.value)}
              placeholder="Ej: 5"
              min={0}
          />
        </div>
        <div className="input">
          <label htmlFor="potencia_input">Potencia de Carga (kW): </label>
          <input
              id="potencia_input"
              type="number"
              value={potenciaCarga}
              onChange={(e) => setPotenciaCarga(e.target.value)}
              placeholder="Ej: 7.5"
              min={0}
          />
        </div>

      <div className='button'>
        <button className='calc' onClick={calcularCarga}>Calcular Carga</button>
      </div>

      {errorMessage && (
          <div className="error-message" role="alert" aria-live="assertive">
          <p>{errorMessage}</p>
        </div>
      )}

      {resultado !== null && (
          <div className={`res ${animarResultado ? 'resultado-animado' : ''}`} aria-live="polite" aria-atomic="true">
          <p>¿Cuánto se cargará la batería?</p>
          <p><strong>{resultado} kWh recuperados</strong></p>
          {parseFloat(capacidadBateria) > 0 && (
            <p style={{ marginTop: '6px' }}>
              = <strong>{((parseFloat(resultado) / parseFloat(capacidadBateria)) * 100).toFixed(1)} %</strong> de la batería
            </p>
          )}
          <div className="icon-container">
            <img src={`${process.env.PUBLIC_URL}/images/bateria01.png`} alt="Icono de Batería" className="icono-bateria" />
          </div>
        </div>
      )}
        </>
      )}
    </div>
    </MouseLightEffect>
  );
}

export default CargaBateria;
